"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupInputFieldName = void 0;
var SignupInputFieldName;
(function (SignupInputFieldName) {
    SignupInputFieldName["Username"] = "username";
    SignupInputFieldName["Phone"] = "phone";
    SignupInputFieldName["Email"] = "email";
    SignupInputFieldName["Password"] = "password";
    SignupInputFieldName["PasswordConfirm"] = "password_confirm";
    SignupInputFieldName["Referral"] = "referral";
    SignupInputFieldName["FirstName"] = "first_name";
    SignupInputFieldName["LastName"] = "last_name";
    SignupInputFieldName["FullName"] = "full_name";
    SignupInputFieldName["Currency"] = "currency";
    SignupInputFieldName["Gender"] = "gender";
    SignupInputFieldName["Language"] = "language";
    SignupInputFieldName["BirthDate"] = "birth_date";
    SignupInputFieldName["Country"] = "country";
    SignupInputFieldName["City"] = "city";
    SignupInputFieldName["State"] = "state";
    SignupInputFieldName["Address"] = "address";
    SignupInputFieldName["ZipCode"] = "zip_code";
    SignupInputFieldName["CpfNumber"] = "cpf_number";
    SignupInputFieldName["Age"] = "age";
})(SignupInputFieldName || (exports.SignupInputFieldName = SignupInputFieldName = {}));
//# sourceMappingURL=signup.fields.js.map